import { useSnackbar } from 'contexts/snackbar';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

export function useNetErrorHandler() {
  const { set } = useSnackbar();
  const { formatMessage } = useIntl();
  const defaultErrorMessage = useMemo(
    () =>
      formatMessage({
        id: 'common.netErrorMessage',
        defaultMessage: 'Something went wrong',
      }),
    [formatMessage],
  );

  return useCallback(
    (error: any) => {
      let message: string;

      if (error.response) {
        message = error.response.data.message;
        if (process.env.NODE_ENV !== 'production' && !message) {
          message = `DEV/TEST error only: ${error.response.data.systemMessage}`;
        }
      } else {
        message = error.message;
      }

      set([
        {
          message: message ?? defaultErrorMessage,
          type: 'error',
        },
      ]);
    },
    [set, defaultErrorMessage],
  );
}
